import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface ProviderDirectoryFacilityState {
  fetchList: boolean;
}

const initialState: ProviderDirectoryFacilityState = {
  fetchList: false,
};

const facilitySlice = createSlice({
  name: "facility",
  initialState,
  reducers: (create) => {
    return {
      setFacilityFetchListRedux: create.reducer(
        (state, action: PayloadAction<boolean>) => {
          state.fetchList = action.payload;
        },
      ),
    };
  },
});

export const { setFacilityFetchListRedux } = facilitySlice.actions;

export default facilitySlice.reducer;
